<template lang="pug">
div
  .award-container()
    .award-top
      .award-top-left
        .award-title 奖励金特权
        .award-font 3倍签到  |  完单即返  |  专属任务
      .award-top-right
        .award-all(@click="goExchange")
          .red-font(v-if="points||recordTotalReceiveBonusNum")
            span {{(signShowStyle?points:recordTotalReceiveBonusNum)||'0'}}
          .black-font(v-if="points||recordTotalReceiveBonusNum") 个
          .award-go
            img(src="https://m.hellobike.com/resource/gallery/61/nq10e1Fi_Group%201707481895.png?x-oss-process=image/quality,q_80")
    .award-line
    .award-middle-block
      .award-middle
        .sign-no-block(v-if="signShowStyle&&!todaySign" @click="goSign")
          .sign-num {{bountyCountToday}}
          .award-sign 签到3倍
        .sign-no-block(v-else)
          .sign-num.op7 {{bountyCountToday}}
          .award-biz 已签到
        .award-middle-list(v-if="awardTotalList.length>0")
          .award-list(v-for="(item,index) in awardTotalList" :class="item.type?'':''")
            .award-num(@click="getAll()") {{item.offerWorth}}
            .award-biz {{item.marketPlanDesc}}
          .award-middle-opacity
        .go-award(v-else="rewardTaskGuidanceList.length>0&&env.isEasyBikeApp")
          .award-list
            .award-item(v-for="(item,index) in rewardTaskList")
              .award-num(@click="goUrl(item)") {{item.offerAmount}}
              .award-biz {{item.showName}}
        .award-button(v-if="awardTotalList.length>0 || (signShowStyle&&!todaySign)"
          @click="getAll(true)") 全部领取
      .task-list(v-if="totalList.length>0&&times>0")
        .task-list-title
          .task-list-title-left 专属奖励金任务
          .task-list-title-right 限时福利 {{d}}天{{h}}:{{ m }}:{{ s }}
        .task-list-block(v-for="(item,index) in totalList" )
          .task-left
            .task-line
            .task-img
              img(:src="item.taskImgUrl")
          .task-right
            .task-line(:style="{ borderTop: index === 0 ? 'none' : '0.005rem solid #e1e6eb' }")
            .task-right-bottom
              .task-middle-block
                .task-middle-block-line
                  .task-middle-block-line-word {{item.mainTitle}}
                  .task-middle-block-line-award
                    img.title-img(src="https://m.hellobike.com/resource/helloyun/08345/qSbGFKFPtD.png")
                    span +{{item.offerWorth}}
                .task-middle-block-line-two 进度{{item.currentProgress}}/{{item.totalProgress}}次
              .task-right-btn( @click="doTask(item)") {{item.btnName}}
        .task-check-more(v-if="true" @click="clickMore")
          .task-check-more-word {{showMore?'查看更多任务':'收起更多任务'}}
          .task-check-more-img
            img(v-if="showMore" src="https://m.hellobike.com/resource/gallery/61/QBx7hjEWo0.png?x-oss-process=image/quality,q_80")
            img(v-else src="https://m.hellobike.com/resource/gallery/61/RJGtlHOj1U.png?x-oss-process=image/quality,q_80")

    signModal(:show.sync="showDialog")
</template>
<script>
import dayjs from 'dayjs';
import Toast from '@/components/toast';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { env, Native } from '@hb/hbridge';
// import { debounce } from '@/utils/index';
import config from '@/const/config';
import {
  getTokenAndLocation, commonGoLink,
} from '@/utils';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import { Navigator } from '@hb/h5-navigator';
import {
  batchReceiveTaskAward, specialBonusTask, doSignTaskAward,
} from '@/api/vip';
import {
  calenderList,
} from '@/utils/calender';
import { showTime } from '../utils.js';
import 'animate.css';
import signModal from './sign-block.vue';


export default {
  components: {
    signModal,
  },
  props: {
    recordTotalReceiveBonusNum: {
      type: String,
      default: '0',
    },
    awardList: {
      type: Array,
      default: () => [],
    },
    signShowStyle: {
      type: Boolean,
      require: true,
    },
    rewardTaskGuidanceList: {
      type: Array,
      default: () => [],
    },
    bountyCountToday: {
      type: String,
      default: '',
    },
    didSignToday: {
      type: Boolean,
      required: true,
    },
    points: {
      type: String,
      default: '0',
    },
  },
  data() {
    return {
      rColor: 'color:#F72626',
      isShowUp: false,
      timer: null,
      timerJump: null,
      env,
      showMore: true,
      taskInfo: [],
      totalList: [],
      // awardTotalList: [],
      rewardTaskList: [],
      todaySign: null,
      calenderObj: calenderList[0],
      hasPermission: null,
      isRemain: false,
      version: '',
      timeout: 0,
      dateTimer: null,
      d: '',
      h: '',
      m: '',
      s: '',
      times: 0,
      showDialog: false,
      // rewardTaskGuidanceList: [{}, {}, {}],
    };
  },

  computed: {
    awardTotalList() {
      return this.awardList.filter((i) => dayjs(i.expiredTime).valueOf() > new Date().getTime());
    },
  },
  watch: {
    didSignToday(val) {
      this.todaySign = val;
    },
    rewardTaskGuidanceList(val) {
      this.rewardTaskList = val;
    },
  },
  async created() {
    this.version = await getVersion();
  },
  mounted() {
    this.todaySign = this.didSignToday;
    this.getTaskList();
    this.rewardTaskList = this.rewardTaskGuidanceList || [];
    // this.checkRemain();
    // this.awardTotalList = this.awardList || [];
  },
  destroyed() {
    this.timer = null;
    this.timerJump = null;
    this.dateTimer = null;
  },
  methods: {
    openTime() {
      const now = new Date().getTime();
      this.times = this.timeout - now;
      this.dateTimer = setInterval(() => {
        if (this.times === 0) {
          clearInterval(this.dateTimer);
          return;
        }
        const time = showTime(this.times);
        this.d = time.D;
        this.h = time.H;
        this.m = time.M;
        this.s = time.S;
        this.times -= 1000;
      }, 1000);
    },
    showBtn() {
      if (!env.isEasyBikeApp) {
        return false;
      } if (env.isIOS && this.version < '6.65') {
        return false;
      }
      return true;
    },
    doTask(item) {
      let channel = 'app';
      if (env.isAliMP || env.isAliMPMonitor) {
        channel = 'ali';
      }
      const link = item.btnLink[channel];
      if (channel === 'ali') {
        Native.callNative({
          method: 'goOperationUrlV2',
          params: link,
        });
      } else {
        window.location.href = link;
      }
    },
    async getTaskList() {
      const { token, cityCode } = await getTokenAndLocation();
      try {
        const res = await specialBonusTask({
          token,
          cityCode,
          appCode: 'platform',
          systemCode: getSystemCode(),
          platform: 4,
        });
        this.taskInfo = res.data.taskInfo;
        this.totalList = this.taskInfo.slice(0, 1);
        this.timeout = res.data.maxExpireTime;
        await this.openTime();
        // eslint-disable-next-line no-empty
      } catch (e) {

      }
    },
    goUrl(item) {
      if (item) {
        Navigator.go(item.jumpUrl);
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_zhuanjinbi',
          categoryId: 'platform',
          businessInfo: {
            businessType: item.showName,
          },
        });
      } else if (this.rewardTaskGuidanceList[0]) {
        UBT.clickButton({
          pageId: 'platform_openedcard_page',
          buttonName: 'platform_zhuanjinbi',
          categoryId: 'platform',
          businessInfo: {
            businessType: this.rewardTaskGuidanceList[0].showName,
          },
        });
        Navigator.go(this.rewardTaskGuidanceList[0].jumpUrl);
      }
    },
    // async deleteRemain() {
    //   UBT.clickButton({
    //     pageId: 'platform_openedcard_page',
    //     buttonName: 'platform_quxiaoqiandaotixing',
    //     categoryId: 'platform',
    //     businessInfo: {},
    //   });
    //   try {
    //     // eslint-disable-next-line no-plusplus
    //     for (let i = 0; i < 7; i++) {
    //       const startTime = parseInt(this.calenderObj.startTime, 10) + i * 86400; // 86400秒为一天
    //       const endTime = parseInt(this.calenderObj.endTime, 10) + i * 86400;
    //       // eslint-disable-next-line no-await-in-loop
    //       const res = await Native.callNative({
    //         classMap: 'message/subscribe',
    //         method: 'msg_deleteCalendarSchedule',
    //         params: {
    //           title: this.calenderObj.title,
    //           startTime,
    //           endTime,
    //           applyAllFuture: true,
    //         },
    //         timeout: false,
    //       });
    //       if (res.isSuccess) {
    //         this.isRemain = false;
    //         Toast.show('取消提醒成功');
    //       }
    //     }
    //   } catch (e) {
    //     // eslint-disable-next-line no-console
    //     console.log(e);
    //   }
    // },
    // async checkRemain() {
    //   const version = await getVersion();
    //   const isLogin = await Native.isLogin();
    //   if (version >= '6.46.0' && isLogin && env.isEasyBikeApp) {
    //     try {
    //       const res = await Native.callNative({
    //         classMap: 'message/subscribe',
    //         method: 'msg_hasCalendarPermission',
    //         params: {},
    //         timeout: false,
    //       });
    //       if (res.hasPermission) {
    //         this.hasPermission = true;
    //         this.check();
    //       } else if (env.isIOS) {
    //         await Native.callNative({
    //           classMap: 'message/subscribe',
    //           method: 'msg_isCalendarScheduleExist',
    //           params: {
    //             title: this.calenderObj.title,
    //             startTime: this.calenderObj.startTime,
    //             endTime: this.calenderObj.endTime,
    //           },
    //           timeout: false,
    //         });
    //         this.hasPermission = true;
    //       } else {
    //         this.hasPermission = false;
    //       }
    //     } catch (e) {
    //       // eslint-disable-next-line no-console
    //       this.hasPermission = false;
    //     }
    //   }
    // },
    // async check() {
    //   try {
    //     const res = await Native.callNative({
    //       classMap: 'message/subscribe',
    //       method: 'msg_isCalendarScheduleExist',
    //       params: {
    //         title: this.calenderObj.title,
    //         startTime: this.calenderObj.startTime,
    //         endTime: this.calenderObj.endTime,
    //       },
    //       timeout: false,
    //     });
    //     if (res.isExist) {
    //       this.isRemain = true;
    //       if (this.todaySign && this.showBtn()) {
    //         UBT.moduleExpose({
    //           pageId: 'platform_openedcard_page',
    //           categoryId: 'platform',
    //           moduleId: 'platform_quxiaoqiandaotixing',
    //           contentId: 'platform_quxiaoqiandaotixing',
    //           exposureTimes: 1,
    //           businessInfo: {},
    //         });
    //       }
    //     } else {
    //       if (this.todaySign && this.showBtn()) {
    //         UBT.moduleExpose({
    //           pageId: 'platform_openedcard_page',
    //           categoryId: 'platform',
    //           moduleId: 'platform_tixingqiandao_click',
    //           contentId: 'platform_tixingqiandao_click',
    //           exposureTimes: 1,
    //           businessInfo: {},
    //         });
    //       }
    //       this.isRemain = false;
    //     }
    //   } catch (e) {
    //     // eslint-disable-next-line no-console
    //     console.log(e);
    //   }
    // },
    // async remainMe() {
    //   UBT.clickButton({
    //     pageId: 'platform_openedcard_page',
    //     buttonName: 'platform_tixingqiandao_click',
    //     categoryId: 'platform',
    //     businessInfo: {},
    //   });
    //   this.checkRemain();
    //   if (this.hasPermission) {
    //     try {
    //       // eslint-disable-next-line no-plusplus
    //       for (let i = 0; i < 7; i++) {
    //         const startTime = parseInt(this.calenderObj.startTime, 10) + i * 86400; // 86400秒为一天
    //         const endTime = parseInt(this.calenderObj.endTime, 10) + i * 86400;
    //         let link = '';
    //         if (config.env === 'fat') {
    //           link = 'https://m.hellobike.com/universal/index.html?target=hellobike%3A%2F%2Fhellobike.com%2FopenWeb%3FwebUrl%3Dhttps%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Ffat%2Flatest%2Findex.html%23%2Fvip%2Fv2%2Ftransfer';
    //         } else if (config.env === 'uat') {
    //           link = 'https://m.hellobike.com/universal/index.html?target=hellobike%3A%2F%2Fhellobike.com%2FopenWeb%3FwebUrl%3Dhttps%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Fuat%2Flatest%2Findex.html%23%2Fvip%2Fv2%2Ftransfer';
    //         } else if (config.env === 'pro') {
    //           link = 'https://m.hellobike.com/universal/index.html?target=hellobike%3A%2F%2Fhellobike.com%2FopenWeb%3FwebUrl%3Dhttps%3A%2F%2Fm.hellobike.com%2FAppPlatformH5%2Flatest%2Findex.html%23%2Fvip%2Fv2%2Ftransfer';
    //         }
    //         // eslint-disable-next-line no-await-in-loop
    //         const res = await Native.callNative({
    //           classMap: 'message/subscribe',
    //           method: 'msg_setCalendarSchedule',
    //           params: {
    //             title: this.calenderObj.title,
    //             startTime,
    //             endTime,
    //             notes: `hellobike://hellobike.com/openWeb?webUrl=https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/vip/v2/transfer`,
    //             description: link,
    //           },
    //         });
    //         if (res.isSuccess) {
    //           if (this.todaySign && this.showBtn()) {
    //             UBT.moduleExpose({
    //               pageId: 'platform_openedcard_page',
    //               categoryId: 'platform',
    //               moduleId: 'platform_quxiaoqiandaotixing',
    //               contentId: 'platform_quxiaoqiandaotixing',
    //               exposureTimes: 1,
    //               businessInfo: {},
    //             });
    //           }
    //           this.isRemain = true;
    //           Toast.show('已开启提醒');
    //         } else {
    //           if (this.todaySign && this.showBtn()) {
    //             UBT.moduleExpose({
    //               pageId: 'platform_openedcard_page',
    //               categoryId: 'platform',
    //               moduleId: 'platform_tixingqiandao_click',
    //               contentId: 'platform_tixingqiandao_click',
    //               exposureTimes: 1,
    //               businessInfo: {},
    //             });
    //           }
    //           this.isRemain = false;
    //         }
    //       }
    //     } catch (e) {
    //       // eslint-disable-next-line no-console
    //       console.log(e);
    //     }
    //   } else {
    //     Toast.show('请开启系统日历权限');
    //   }

    //   // eslint-disable-next-line no-plusplus
    // },
    clickMore() {
      if (this.showMore) {
        this.totalList = this.taskInfo;
      } else {
        this.totalList = this.taskInfo.slice(0, 1);
      }
      this.showMore = !this.showMore;
    },
    goExchange() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_exchange',
        categoryId: 'platform',
        businessInfo: {},
      });
      const link = `https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env}/` : ''
      }latest/index.html#/bounty?adsource=dandanfan`;
      commonGoLink(link);
    },
    async getAward(item) {
      const { token } = await getTokenAndLocation();
      try {
        const res = await batchReceiveTaskAward({
          token,
          channelId: env.platformCode,
          systemCode: getSystemCode(),
          infos: [
            item,
          ],
        });
        if (res) {
          this.$emit('refresh', item);
        }
      } catch (e) {
        Toast.show(e || '领取失败');
      }
    },
    async goSign() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_qiandao_click',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndLocation();
      try {
        const res = await doSignTaskAward({
          systemCode: getSystemCode(),
          token,
        });
        if (res.data) {
          if (res.data.repeatSignDesc) {
            Toast.show(res.data.repeatSignDesc);
            this.todaySign = true;
          } else if (res.data.didSignToday) {
            this.todaySign = true;
            this.total = this.bountyCountToday;
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_qiandaochenggong',
              contentId: 'platform_qiandaochenggong',
              exposureTimes: 1,
              businessInfo: {},
            });
            this.showDialog = true;
          } else {
            this.todaySign = false;
            this.showDialog = true;
            UBT.moduleExpose({
              pageId: 'platform_openedcard_page',
              categoryId: 'platform',
              moduleId: 'platform_qiandaochenggong',
              contentId: 'platform_qiandaochenggong',
              exposureTimes: 1,
              businessInfo: {},
            });
          }
        }
        this.$emit('refresh');
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
    async getAll(val) {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_order_return',
        categoryId: 'platform',
        businessInfo: {},
      });
      const { token } = await getTokenAndLocation();
      try {
        const res = await batchReceiveTaskAward({
          token,
          channelId: env.platformCode,
          systemCode: getSystemCode(),
          infos: this.awardTotalList,
        });
        if (res) {
          this.timer = setTimeout(() => {
            this.$emit('refresh', this.awardTotalList);
          }, 500);
        }
        if (val && !this.todaySign) {
          this.goSign();
        }
      } catch (e) {
        Toast.show(e || '领取失败');
      }
    },
    getTime(time) {
      const date1 = dayjs(time);
      date1.diff(dayjs(`${new Date()}`).format('YYYY-MM-DD HH:mm:ss'), 'day'); // 7
      if (date1.diff(dayjs(`${new Date()}`).format('YYYY-MM-DD HH:mm:ss'), 'day') >= 1) {
        return `还剩${date1.diff(dayjs(`${new Date()}`).format('YYYY-MM-DD HH:mm:ss'), 'day')}天`;
      }
      return '即将过期';
    },
    timeColor(time) {
      const date1 = dayjs(time);
      const date2 = date1.diff(dayjs(`${new Date()}`).format('YYYY-MM-DD HH:mm:ss'), 'day'); // 7
      if (date2 > 1) {
        return true;
      }
      return false;
    },
    goRecharge() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_chongzhi',
        categoryId: 'platform',
        businessInfo: {},
      });
      commonGoLink('https://m.hellobike.com/AppFinanceRechargeH5/latest/pr_index_home.html#/home?hiddenNavigationBar=1&source=F_Recharge_APP_jianglijin_superVIP');
    },
    goCardCity() {
      UBT.clickButton({
        pageId: 'platform_openedcard_page',
        buttonName: 'platform_buycard',
        categoryId: 'platform',
        businessInfo: {},
      });
      this.timerJump = setTimeout(() => {
        if (env.isEasyBikeApp) {
          window.location.href = 'https://m.hellobike.com/AppBikeMallH5/latest/index.html#/mall?adsource=member_app';
        } else {
          window.location.href = 'https://m.hellobike.com/AppBikeMallH5/latest/index.html#/mall?adsource=member_alipay';
        }
      }, 200);
    },
  },
};
</script>
<style lang="less" scoped>
.scrollDown {
  animation: backOutUp;

  /* referring directly to the animation's @keyframe declaration */
  animation-duration: 0.8s;

  /* don't forget to set a duration! */
  // --animate__slow: 0.3s;
}

.op7 {
  opacity: 0.5;
}

.award-container {
  width: 100%;
  background: #fff;
  border-radius: 0.16rem;
  margin-top: -0.8rem;

  .award-top {
    padding: 0.14rem 0.14rem 0 0.16rem;
    display: flex;
    justify-content: space-between;

    .award-top-left {
      .award-title {
        font-size: 0.16rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 600;
        color: #242729;
        line-height: 0.22rem;
      }

      .award-font {
        margin-top: 0.02rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;
      }
    }

    .award-top-right {
      display: flex;

      .award-all {
        margin-top: 0.02rem;
        margin-right: 0.08rem;
        display: flex;

        .red-font {
          margin-left: 0.02rem;
          font-size: 0.24rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: 700;
          color: #fa4614;
          line-height: 0.27rem;
        }

        .black-font {
          font-size: 0.13rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #242729;
          line-height: 0.31rem;
        }

        .award-go {
          margin-top: 0.08rem;

          img {
            width: 0.12rem;
            height: 0.12rem;
          }
        }
      }
    }
  }

  .award-line {
    width: 100%;
    height: 0.05rem;
    background-image: url(https://m.hellobike.com/resource/gallery/63/RnRE1bx9L8.png?x-oss-process=image/quality,q_80);
    background-size: 100% 100%;
    margin-bottom: -0.02rem;
  }

  .award-middle-block {
    width: 100%;
    position: relative;
    background: linear-gradient(360deg, #fefbf6 44.51%, #fff5d1 100%);
    border: 0.5px solid #ffedaf;
    border-radius: 0 0 0.16rem 0.16rem;
    overflow: hidden;

    .award-middle {
      margin-top: 0.02rem;
      width: 100%;
      display: flex;
      padding-bottom: 0.16rem;
      padding-left: 0.05rem;
      position: relative;

      .sign-no-block {
        padding-top: 0.11rem;
        min-width: 0.7rem;

        .sign-num {
          margin: 0 auto;
          background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
          background-size: 100% 100%;
          width: 0.38rem;
          height: 0.38rem;
          font-size: 0.13rem;
          font-family: DINAlternate-Bold, DINAlternate, sans-serif;
          font-weight: bold;
          color: #a36a01;
          line-height: 0.38rem;
          text-align: center;
        }

        .award-sign {
          margin: 0.03rem auto 0 auto;
          width: 0.48rem;
          height: 0.16rem;
          border-radius: 0.5rem;
          background: #ff5526;
          color: #fff;
          text-align: center;
          line-height: 0.16rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-size: 0.11rem;
        }

        .award-biz {
          min-width: 0.38rem;
          margin: 0.03rem auto 0 auto;
          text-align: center;
          font-size: 0.12rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #deb1a5;
          height: 0.16rem;
          line-height: 0.15rem;
          border: 0.5px solid #deb1a5;
          border-radius: 0.5rem;
        }
      }

      .award-middle-list {
        display: flex;
        width: 100%;
        flex-wrap: nowrap;
        overflow-x: auto;
        padding: 0.11rem 0 0 0;

        .award-list {
          width: 0.6rem;
          flex: 0 0 auto;

          .award-num {
            margin: 0 auto;
            background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
            background-size: 100% 100%;
            width: 0.38rem;
            height: 0.38rem;
            font-size: 0.14rem;
            font-family: DINAlternate-Bold, DINAlternate, sans-serif;
            font-weight: bold;
            color: #7d3b2a;
            line-height: 0.38rem;
            text-align: center;
          }

          .award-biz {
            margin-top: 0.03rem;
            text-align: center;
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-weight: 400;
            color: #6c747a;
          }

          .award-sign {
            margin: 0.03rem auto 0 auto;
            width: 0.48rem;
            height: 0.16rem;
            border-radius: 0.5rem;
            background: #ff5526;
            color: #fff;
            text-align: center;
            line-height: 0.16rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            font-size: 0.11rem;
          }
        }
      }

      .award-middle-list::-webkit-scrollbar {
        display: none;
      }

      .go-award {

        .award-list {
          overflow: scroll;
          display: flex;
          width: 100%;
          padding-top: 0.11rem;

          &::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
            color: transparent;
          }

          .award-item {
            flex-shrink: 0;
            margin-right: 0.1rem;

            .award-num {
              background-image: url(https://m.hellobike.com/resource/helloyun/08345/iBMsO8400i.png);
              background-size: 100% 100%;
              width: 0.38rem;
              height: 0.38rem;
              font-size: 0.14rem;
              font-family: DINAlternate-Bold, DINAlternate, sans-serif;
              font-weight: bold;
              color: #7d3b2a;
              line-height: 0.38rem;
              text-align: center;
              margin: 0 auto;
              opacity: 0.5;
            }

            .award-biz {
              min-width: 0.38rem;
              margin: 0.03rem auto 0 auto;
              text-align: center;
              font-size: 0.12rem;
              font-family: pingfangsc-regular, pingfang sc, sans-serif;
              font-weight: 400;
              color: #deb1a5;
              height: 0.16rem;
              line-height: 0.16rem;
              border: 0.5px solid #deb1a5;
              padding: 0 0.06rem;
              border-radius: 0.5rem;
            }

            .award-day {
              width: 0.6rem;
              text-align: center;
              font-size: 0.11rem;
              font-family: pingfangsc-regular, pingfang sc, sans-serif;
              font-weight: 400;
              color: rgba(83, 25, 0, 0.5);
            }
          }
        }

        .award-button {
          margin-top: 0.18rem;
          width: 1.26rem;
          height: 0.32rem;
          border-radius: 0.16rem;
          border: 0.01rem solid #fb7c59;
          font-family: pingfangsc-regular, pingfang sc, sans-serif;
          font-weight: 500;
          font-size: 0.14rem;
          color: #fa4614;
          line-height: 0.3rem;
          text-align: center;
        }
      }

      .award-button {
        position: absolute;
        top: 0.19rem;
        right: 0.14rem;
        width: 0.74rem;
        height: 0.32rem;
        background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
        border-radius: 0.5rem;
        font-size: 0.14rem;
        font-family: PingFangSC-Medium, PingFang SC, sans-serif;
        font-weight: 500;
        color: #fff;
        text-align: center;
        line-height: 0.32rem;
      }
    }

    .task-list {
      margin-top: 0.05rem;
      padding: 0 0.16rem 0.08rem 0.16rem;

      .task-list-title {

        display: flex;

        .task-list-title-left {
          font-family: Alibaba PuHuiTi 2, sans-serif;
          font-size: 0.14rem;
          font-weight: 800;
          color: #242729;
        }

        .task-list-title-right {
          margin-top: 0.02rem;
          margin-left: 0.04rem;
          font-family: pingfangsc-regular, pingfang sc, sans-serif;
          font-size: 0.12rem;
          font-weight: 400;
          line-height: 0.168rem;
          text-align: left;
          color: #6c747a;
        }
      }

      .task-list-block {
        display: flex;
        height: 0.66rem;

        .task-left {
          .task-line {
            height: 0.125rem;
            width: 0.4rem;
          }

          .task-img {
            img {
              width: 0.4rem;
              height: 0.4rem;
            }
          }
        }

        .task-right {
          width: 100%;

          .task-line {
            width: 100%;
            height: 0.125rem;
          }

          .task-right-bottom {
            display: flex;
            justify-content: space-between;

            .task-middle-block {
              margin-left: 0.08rem;

              .task-middle-block-line {
                display: flex;

                .task-middle-block-line-word {
                  font-family: PingFangSC-Medium, PingFang SC, sans-serif;
                  font-size: 0.14rem;
                  font-weight: 500;
                  color: #242729;
                }

                .task-middle-block-line-award {
                  margin-top: 0.03rem;
                  height: 0.14rem;
                  background: #ffefd6;
                  border-radius: 0.5rem;
                  margin-left: 0.08rem;
                  color: #fa4614;
                  font-weight: 500;
                  font-size: 0.12rem;
                  line-height: 0.14rem;
                  display: flex;
                  padding-right: 0.03rem;

                  img {
                    width: 0.14rem;
                    height: 0.14rem;
                    border-radius: 50%;
                  }
                }
              }

              .task-middle-block-line-two {
                font-family: PingFangSC-Medium, PingFang SC, sans-serif;
                font-size: 0.12rem;
                font-weight: 400;
                color: #879099;
              }
            }

            .task-right-btn {
              margin-top: 0.08rem;
              width: 0.62rem;
              height: 0.26rem;
              border-radius: 0.5rem;
              color: #fa4614;
              text-align: center;
              line-height: 0.26rem;
              background: #fff1db;
              font-size: 0.12rem;
            }

            .task-right-get-btn {
              display: flex;
              justify-content: center;
              margin-top: 0.08rem;
              width: 0.63rem;
              height: 0.26rem;
              background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
              color: #fff;
              font-size: 0.12rem;
              line-height: 0.26rem;
              border-radius: 0.5rem;

              img {
                margin-top: 0.06rem;
                margin-left: 0.03rem;
                width: 0.14rem;
                height: 0.14rem;
              }
            }
          }
        }
      }

      .task-check-more {
        display: flex;
        justify-content: center;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-size: 0.12rem;
        font-weight: 400;
        color: #879099;

        .task-check-more-img {
          margin-left: 0.02rem;
          margin-top: 0.03rem;

          img {
            width: 0.12rem;
            height: 0.12rem;
          }
        }
      }
    }
  }

  .award-middle-opacity {
    position: absolute;
    right: 0.05rem;
    top: 0;
    width: 0.9rem;
    height: 0.8rem;
  }

  .award-bottom {
    margin: 0 auto;
    margin-top: 0.15rem;
    width: 98%;
    height: 0.37rem;
    background: #fff6f2;
    border-radius: 0 0 0.12rem 0.12rem;
    font-size: 0.12rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #879099;
    line-height: 0.37rem;
    text-align: center;
  }
}
</style>
